module.exports = __webpack_public_path__ + "assets/img/组 4@2x.d2df58ad.png";